import React from 'react';
import { useSelector } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import { AppState } from 'services/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectFertilizerWorksheetComments } from './selectors';

export interface Props {
    pageIndex: WorksheetPageIndex;
}

export default function FertilizerPrintWorksheetComments(
    props: Props
): React.ReactElement | null {
    const comments = useSelector((state: AppState) =>
        makeSelectFertilizerWorksheetComments()(state, props)
    );

    if (!comments || !comments.length) return null;

    return (
        <Grid className="additional-comments-section">
            <Grid.Row>
                <Grid.Column
                    width="16"
                    className="additional-comments-section-title"
                >
                    <span>Additional comments:</span>
                </Grid.Column>
                {comments.map((comment, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Grid.Column width="16" key={index}>
                        <span className="additional-comments-section-text">
                            - {comment}
                        </span>
                    </Grid.Column>
                ))}
            </Grid.Row>
        </Grid>
    );
}
